import { render, staticRenderFns } from "./AccordianItem.vue?vue&type=template&id=42b8a1b1&scoped=true"
import script from "./AccordianItem.vue?vue&type=script&lang=js"
export * from "./AccordianItem.vue?vue&type=script&lang=js"
import style0 from "./AccordianItem.vue?vue&type=style&index=0&id=42b8a1b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8a1b1",
  null
  
)

export default component.exports